import Alpine from 'alpinejs';

const trackClickAttrName = 'data-tracking-name';

const trackingClickHandler = (event: Event) => {
  const target = event.target as HTMLElement;
  const trackingName = target.getAttribute(trackClickAttrName);

  if (trackingName && trackingName !== 'None') {
    window.fathom.trackEvent(trackingName);
  }
};

Alpine.data('trackingData', () => ({
  init: async () => {
    const elements = document.querySelectorAll(`[${trackClickAttrName}]`);

    elements.forEach((el) => {
      console.log(el);
      el.addEventListener('click', trackingClickHandler);
    });
  },
}));
